import { makeRequest } from './data_utils';

const getStats = () => {
    const endpoint = `api/stats`;
    return makeRequest(endpoint, 'GET');
};

export const statsData = {
    getStats
};

// Also export the function directly for debugging
export { getStats }; 